import React, { useState } from "react";
import styled from "styled-components";
import { T, FONTS, FS } from "../tokens";
import { Icon } from "./Icons";

const UnassignedDocRow = ({ doc, pgCount, bundles, onAssign }) => {
  const [target, setTarget] = useState("");
  const [isOpen, setIsOpen] = useState(false);

  const selectedBundle = bundles.find((b) => b.code === target);

  return (
    <Row>
      <Icon.File size={13} color={T.mute} />
      <DocName title={doc.name}>
        {doc.name}{" "}
        <PgCount>
          · {pgCount} page{pgCount !== 1 ? "s" : ""}
        </PgCount>
      </DocName>

      <SelectWrapper>
        <ModernSuperSelect
          className={isOpen ? "open" : ""}
          onClick={() => setIsOpen(!isOpen)}
        >
          <SelectValue>
            {selectedBundle
              ? `[${selectedBundle.prefix || selectedBundle.code}] ${selectedBundle.name}`
              : "Select"}
          </SelectValue>
        </ModernSuperSelect>

        <Menu className={isOpen ? "open" : ""}>
          <MenuItem
            className={target === "" ? "selected" : ""}
            onClick={() => {
              setTarget("");
              setIsOpen(false);
            }}
          >
            Select
          </MenuItem>
          {bundles.map((b) => (
            <MenuItem
              key={b.code}
              className={b.code === target ? "selected" : ""}
              onClick={() => {
                setTarget(b.code);
                setIsOpen(false);
                onAssign(b.code);
              }}
            >
              [{b.prefix || b.code}] {b.name}
            </MenuItem>
          ))}
        </Menu>
      </SelectWrapper>
    </Row>
  );
};

export default UnassignedDocRow;

const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 7px 10px;
  border-radius: 7px;
  background: ${T.white};
  border: 1px solid ${T.line};
  margin-bottom: 6px;
  position: relative;

  &:last-child {
    margin-bottom: 0;
  }
`;

const DocName = styled.span`
  flex: 1;
  font-family: ${FONTS.primaryFontRegular};
  font-size: ${FS.base};
  color: ${T.ink};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
`;

const PgCount = styled.span`
  font-family: ${FONTS.primaryFontRegular};
  font-size: ${FS.xs};
  color: ${T.mute};
`;

const SelectWrapper = styled.div`
  position: relative;
  width: 180px;
  flex-shrink: 0;
`;

const ModernSuperSelect = styled.div`
  height: 36px;
  padding: 0 14px;
  border-radius: 10px;
  border: 2px solid ${T.line};
  background: ${T.white};
  font-family: ${FONTS.primaryFontSemiBold};
  font-size: ${FS.base};
  color: ${T.ink};
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  transition: all 0.2s ease;
  user-select: none;
  white-space: nowrap;

  &:hover {
    box-shadow: 0 0 0 3px rgba(0, 180, 160, 0.08);
  }

  &.open {
    box-shadow: 0 0 0 4px rgba(0, 180, 160, 0.15);
  }
`;

const SelectValue = styled.span`
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const Menu = styled.ul`
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  background: ${T.white};
  border-radius: 10px;
  box-shadow: 0 12px 30px -6px rgba(0, 0, 0, 0.12);
  max-height: 260px;
  overflow-y: auto;
  z-index: 100;
  padding: 6px 0;
  list-style: none;
  opacity: 0;
  visibility: hidden;
  transform: translateY(-8px);
  transition: all 0.22s ease;

  &.open {
    opacity: 1;
    visibility: visible;
    transform: translateY(0);
  }

  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background: ${T.line};
    border-radius: 10px;
  }
`;

const MenuItem = styled.li`
  padding: 11px 16px;
  color: ${T.ink};
  cursor: pointer;
  transition: all 0.15s ease;

  &:hover {
    background: rgba(0, 180, 160, 0.08);
    color: ${T.teal};
  }

  &.selected {
    background: rgba(0, 180, 160, 0.12);
    color: ${T.teal};
    font-family: ${FONTS.primaryFontSemiBold};
  }
`;
